<template>
  <div class="pagination">
    <button 
      class="pagination-button" 
      :disabled="currentPage === 1"
      @click="$emit('change-page', currentPage - 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="pagination-icon">
        <path d="M15 18l-6-6 6-6"/>
      </svg>
      Previous
    </button>
    <div class="pagination-info">
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <span class="total-info">{{ totalItems }} courses</span>
    </div>
    <button 
      class="pagination-button" 
      :disabled="currentPage === totalPages"
      @click="$emit('change-page', currentPage + 1)"
    >
      Next
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="pagination-icon">
        <path d="M9 18l6-6-6-6"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CoursePagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  emits: ['change-page']
};
</script> 